import React from "react";
import { ShareButton } from "../../atoms/form/button/share";
import styled from "styled-components";
import { RiInstagramLine } from "react-icons/ri";
import { Flex } from "rebass/styled-components";
import { openWebShare, trackClipSocialShare } from "./utils";

const StyledBackground = styled(Flex)`
  position: relative;
  padding: 8px;
  background: #f09433;
  background: linear-gradient(
    45deg,
    #f2bc64 0%,
    #f27854 25%,
    #d84264 50%,
    #a63c95 75%,
    #606ca9 100%
  );
  border-radius: 50%;
`;

const StyledShare = styled(RiInstagramLine)`
  position: relative;
  color: #ffffff;
`;

export default function InstagramShare({ clip, file, ...props }) {
  return (
    <>
      <ShareButton
        justifyContent="center"
        alignItems="center"
        target="_blank"
        onClick={async () => {
          try {
            openWebShare({ file, clip });
            trackClipSocialShare({
              platform: "App Share",
              clip,
            });
          } catch (e) {}
        }}
        {...props}
      >
        <Flex alignItems="center">
          <StyledBackground>
            <StyledShare size={16}></StyledShare>
          </StyledBackground>
          <Flex alignItems="flex-start" flexDirection="column"></Flex>
          {props.children}
        </Flex>
      </ShareButton>
    </>
  );
}
